const WELCOME_MESSAGES = [
  "Hoy empieza contigo.",
  "Qué bien que estés aquí.",
  "Sigamos construyendo juntos.",
  "Hagamos que las cosas pasen.",
  "Tú das el siguiente paso.",
] as const;

const calendar = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Europe/Madrid",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

export function getWelcomeMessage(now: Date): string {
  const parts = calendar.formatToParts(now);
  const value = (type: Intl.DateTimeFormatPartTypes) =>
    Number(parts.find((part) => part.type === type)?.value);
  const date = new Date(Date.UTC(value("year"), value("month") - 1, value("day")));
  const weekday = (date.getUTCDay() + 6) % 7;
  const monday = date.getTime() - weekday * 86_400_000;
  let seed = Math.floor(monday / 86_400_000);
  const order: string[] = [...WELCOME_MESSAGES];
  for (let index = order.length - 1; index > 0; index -= 1) {
    seed = (Math.imul(seed, 1664525) + 1013904223) >>> 0;
    const selected = Math.floor((seed / 4294967296) * (index + 1));
    [order[index], order[selected]] = [order[selected], order[index]];
  }
  return order[Math.min(weekday, 4)];
}
